"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useDetectOutsideClick_1 = require("../../hooks/useDetectOutsideClick");
var ChoiceFilter_1 = require("./ChoiceFilter");
var StateChoice_1 = require("./StateChoice");
var TextInputFilter_1 = __importDefault(require("./TextInputFilter"));
var DisctrictFilter_1 = require("./DisctrictFilter");
var BuildingNameAutoComplete_1 = __importDefault(require("./BuildingNameAutoComplete"));
var PublicCodeInput_1 = __importDefault(require("./PublicCodeInput/PublicCodeInput"));
var classnames_1 = __importDefault(require("classnames"));
var FilterItem = function (_a) {
    var filter = _a.filter, changeFilter = _a.changeFilter, onStateChange = _a.onStateChange, onDistrictChange = _a.onDistrictChange, handlePublicCode = _a.handlePublicCode, handleBuildingNameChange = _a.handleBuildingNameChange, appliedFilters = _a.appliedFilters;
    var dropdownRef = react_1.useRef(null);
    var _b = useDetectOutsideClick_1.useDetectOutsideClick(dropdownRef, false), isActive = _b[0], setIsActive = _b[1];
    var filterClassName = react_1.useMemo(function () {
        return filter.component
            .split(/(?=[A-Z])/)
            .join('-')
            .toLowerCase();
    }, [filter.component]);
    var toggleDropdown = function () {
        setIsActive(!isActive);
    };
    var formLayout = function (filter) {
        var requiredProps = {
            filter: filter,
            changeFilter: changeFilter,
            toggleDropdown: toggleDropdown,
            appliedFilters: appliedFilters,
        };
        switch (filter.component) {
            case 'MultipleChoice':
            case 'SingleChoice':
                return react_1.default.createElement(ChoiceFilter_1.ChoiceFilter, __assign({}, requiredProps));
            case 'TextInput':
                return react_1.default.createElement(TextInputFilter_1.default, __assign({}, requiredProps));
            case 'StateChoice':
                return (react_1.default.createElement(StateChoice_1.StateChoice, __assign({ onSelect: onStateChange }, requiredProps)));
            case 'DistrictChoice':
                return (react_1.default.createElement(DisctrictFilter_1.DistrictChoice, __assign({ onSelect: onDistrictChange }, requiredProps)));
            case 'BuildingNameAutoComplete':
                return (react_1.default.createElement(BuildingNameAutoComplete_1.default, __assign({ onSelect: handleBuildingNameChange }, requiredProps)));
            case 'PublicCodeInput':
                return (react_1.default.createElement(PublicCodeInput_1.default, __assign({ onSelect: handlePublicCode }, requiredProps)));
            default:
                return react_1.default.createElement(react_1.default.Fragment, null);
        }
    };
    return (react_1.default.createElement("div", { ref: dropdownRef, className: classnames_1.default("filter f-" + filterClassName, {
            active: isActive,
            selected: appliedFilters[filter.name].length,
        }) }, formLayout(filter)));
};
exports.default = FilterItem;
